import React from 'react';
import usePortal from '../../../../utils/react/usePortal';
import Drawer from '../../../../components/Drawer';
import styled from 'styled-components';
const OpenButton = styled.button`
  background-color: transparent;
  background-image: none;
  border: 0;
  padding: 0;
  font-weight: 700;
  color: #0000ee;

  & > img {
    margin-left: 5px;
  }
`;
export const DisclosureLinkWithDrawer = ({
  displayTitle,
  subtitle,
  children
}) => {
  const {
    isOpen,
    togglePortal,
    Portal
  } = usePortal({
    onOpen: args => {
      const {
        portal
      } = args;
      portal.current.style.cssText = `
        z-index: 11;
        position: relative;
      `;
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, typeof children !== 'string' ?
  /*#__PURE__*/
  // inline link
  React.createElement("span", {
    style: {
      color: '#0000EE',
      cursor: 'pointer'
    },
    onKeyDown: togglePortal,
    onClick: togglePortal,
    tabIndex: 0,
    role: "button"
  }, displayTitle) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OpenButton, {
    onClick: togglePortal,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", null, displayTitle), /*#__PURE__*/React.createElement("img", {
    alt: displayTitle,
    src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0tOC02aDI0djI0SC04eiIvPjxwYXRoIGQ9Ik0uNzEgMTEuM2MuMzkuMzkgMS4wMi4zOSAxLjQxIDBsNC41OS00LjU5YS45OTYuOTk2IDAgMDAwLTEuNDFMMi4xMi43MUEuOTk2Ljk5NiAwIDEwLjcxIDIuMTJsMy44OCAzLjg5TC43MSA5Ljg5Yy0uMzkuMzktLjM4IDEuMDMgMCAxLjQxeiIgZmlsbD0iIzAwNDlEQiIvPjwvZz48L3N2Zz4=",
    height: 8,
    width: 5
  })), /*#__PURE__*/React.createElement("p", null, subtitle)), isOpen && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Drawer, {
    onClose: togglePortal
  }, children)));
};